import './modal-title.css';
import { jsx } from 'react/jsx-runtime';
import styles from './modal-title.module.scss.js';

/**
 * @component Modal
 * @package Modals
 */
const ModalTitle = ({ children, primitive = 'h2', 'data-testid': testId = 'modal-title', colorMode = 'light', noCloseButton, }) => {
    const Primitive = primitive;
    const modalTitleStyles = [styles.modalTitle];
    if (colorMode === 'dark') {
        modalTitleStyles.push(styles.dark);
    }
    if (noCloseButton) {
        modalTitleStyles.push(styles.noCloseButton);
    }
    return (jsx(Primitive, { "data-testid": testId, className: modalTitleStyles.join(' '), children: children }));
};

export { ModalTitle as default };
